<template>
    <div class="inner with-content">

        <div class="headline">
            <h1>{{ $t('contracts.create.headline') }}</h1>
        </div>

        <div class="upload-container small">
            <div class="top">
                <h2>{{ $t('propertyselector.headline') }}</h2>
                <p>{{ $t('propertyselector.text') }}</p>
            </div>

            <PropertySelector v-model="selectedPropertyId" :url="addUrl"/>

            <button disabled class="purple continue"
                    @click.prevent="nextStep">
                <span v-if="state === 'loading'">{{ $t('property.loading.message') }}</span>
                <span v-else>{{ $t('button.continue') }}</span>
            </button>
        </div>

    </div>
</template>

<script>

import {mapGetters} from 'vuex';
import PropertySelector from './../../components/PropertySelector.vue';
import createEntity from "../../mixins/create-entity";
export default {
    mixins: [createEntity],
    components: {
        PropertySelector
    },
    data: () => ({
        cloneId: null,
        selectedPropertyId: null,
        state: 'ready'
    }),
    computed: {
        ...mapGetters([
            'getProperties',
            'getSingleProperty',
            'getToken'
        ]),
        addUrl() {
            return '/properties/add?return=digital-contract' + (this.$route.query.clone ? ('&clone=' + this.$route.query.clone) : '');
        }
    },
    methods: {
        nextStep() {
            this.state = 'loading';

            if (this.cloneId) {
                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/draft-contract/' + this.cloneId + '/duplicate',
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        property_id: this.selectedPropertyId,
                    }
                }).then(response => this.$router.push('/contracts/digital-contract/edit/' + response.data.draft_contract_id))
            } else {

                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/draft-contract',
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        property_id: this.selectedPropertyId,
                        tenantId: this.$route.query.tenant
                    }
                }).then(response => {
                    this.$store.dispatch('fetchDraftContracts', true).then(
                        () => {
                            this.$store.dispatch('fetchSingleDraftContract', response.data.draft_contract_id).then(
                                () => {
                                    this.$store.commit('setSuccessBarMessage', this.$t('successbar.digital-contracts.created.message'));
                                    this.$router.push('/contracts/digital-contract/edit/' + response.data.draft_contract_id)
                                }
                            )
                        }
                    )
                }).finally(e => {
                    this.state = 'ready';
                })
            }
        }
    },
    mounted() {
        this.cloneId = this.$route.query.clone;

        if (this.$route.query.property) {
            this.selectedPropertyId = this.$route.query.property;
            this.nextStep();
        }
    }
}
</script>
